// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--dDepd";
export var Container = "styles-module--Container--J7KGW";
export var Footer = "styles-module--Footer--NvBWC";
export var Header = "styles-module--Header--8bJTO";